document.addEventListener('DOMContentLoaded', () => {
  const grid = document.querySelector('#product-grid');
  if (!grid) return;

  // Run on ALL collection pages
  if (!window.location.pathname.startsWith('/collections/')) return;

  let currentPage = 1;
  let isLoading = false;
  let hasMore = true;

  // Load earlier for smoother feel
  const thresholdPx = 1800;

  /* ===============================
     End of results message
  =============================== */
  const endMessage = document.createElement('div');
  endMessage.className = 'infinite-end-message';
  endMessage.textContent = "You've reached the end of our current stock.";
  endMessage.style.display = 'none';
  grid.parentElement.appendChild(endMessage);

  /* ===============================
     Move SOLD OUT items to bottom
  =============================== */
  function moveSoldOutToBottom() {
    const items = Array.from(grid.querySelectorAll('.grid__item'));
    if (!items.length) return;

    const inStock = [];
    const soldOut = [];

    items.forEach(item => {
      const text = item.innerText.toLowerCase();
      const isSoldOut = text.includes('sold out');
      (isSoldOut ? soldOut : inStock).push(item);
    });

    [...inStock, ...soldOut].forEach(el => grid.appendChild(el));
  }

  /* ===============================
     Load next page
  =============================== */
  async function loadNextPage() {
    if (isLoading || !hasMore) return;

    isLoading = true;
    currentPage += 1;

    const nextUrl = `${window.location.pathname}?page=${currentPage}`;

    try {
      const res = await fetch(nextUrl);
      if (!res.ok) {
        stopInfiniteScroll();
        return;
      }

      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const newItems = doc.querySelectorAll('#product-grid .grid__item');

      // No more products = stop forever
      if (!newItems.length) {
        stopInfiniteScroll();
        return;
      }

      newItems.forEach(item => grid.appendChild(item));
      moveSoldOutToBottom();

    } catch (err) {
      stopInfiniteScroll();
    } finally {
      isLoading = false;
    }
  }

  /* ===============================
     Stop infinite scroll cleanly
  =============================== */
  function stopInfiniteScroll() {
    hasMore = false;
    window.removeEventListener('scroll', onScroll);
    endMessage.style.display = 'block';
  }

  /* ===============================
     Scroll watcher
  =============================== */
  function onScroll() {
    if (
      window.innerHeight + window.scrollY >=
      document.body.offsetHeight - thresholdPx
    ) {
      loadNextPage();
    }
  }

  // Initial pass
  moveSoldOutToBottom();
  window.addEventListener('scroll', onScroll);
});
